module.exports = __webpack_public_path__ + "img/Frage5_2048x1536.e889614d.jpg";